import {useEffect, useState} from "react";
import "./../App.css"
import { HiOutlineLocationMarker } from "react-icons/hi";
import { TbMail } from "react-icons/tb";
import { IoCallOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import logoSVG from '../Images/Qulabslogo.png';
import logoQAIGSVG from "../../src/Images/QuantumAILogo.png";
import { generateSvgDataUrl } from "./Dimensions";
import { SlSocialLinkedin } from "react-icons/sl";
import { currentSite } from "../Config/siteConfig";

export default function Footer(props) {
  const backgroundImageBig = generateSvgDataUrl("#060606",70,70);
  const backgroundImageSmall = generateSvgDataUrl("#060606",50,50);
  const [backgroundImage, setBackgroundImage] = useState(backgroundImageSmall);

  useEffect(() => {
    const updateBackgroundImage = () => {
      const screenWidth = window.innerWidth;

      if (screenWidth >= 1536) {
        setBackgroundImage(backgroundImageBig);
      } else {
        setBackgroundImage(backgroundImageSmall);
      }
    };

    updateBackgroundImage();
    
  }, []);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const navigate = useNavigate();
 

  const openYoutubeProfile = () => {
    window.open('https://youtube.com/@quantum_ai_global?si=_6-j9dasMGM6lEDj', '_blank');
  };

  const openTwitterProfile = () => {
    window.open('https://x.com/quantumaiglobal?s=11', '_blank');
  };

  const openLinkedInProfile = () => {
    window.open(
      "https://www.linkedin.com/company/qulabs-software-india/",
      "_blank",
    );
  };

    const openQAIGLinkedInProfile = () => {
      window.open(
        "https://www.linkedin.com/company/quantum-ai-global-company/mycompany/",
        "_blank",
      );
    };
  return (
    <div
      className={`flex flex-col gap-10 lg:gap-0 items-center justify-center w-full h-auto bg-primary7 `}
    >
      {props.showpage && (
        <div
          className="width flex flex-col  relative inset-0 gap-4 xl:w-[72rem] lg:w-[900px] w-[20rem] h-auto  border-[0.06rem] border-[#1B99D4] px-[2.25rem] py-[1.25rem] rounded-3xl mt-10 "
          style={{ backgroundImage: `url(${backgroundImage})` }}
        >
          <div
            className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 inset-0 w-full md:w-[50rem] h-[15rem] -z-2"
            style={{
              background:
                "radial-gradient(circle at center, rgba(77,118,244,0.3), transparent )",
              filter: "blur(70px)",
            }}
          ></div>

          <div className="text-center text-[#1B99D4] font-RobotoBold text-[1.5rem] md:text-[2rem] 2xl:text-[2.3rem]">
            Where can you find us?
          </div>
          {currentSite === "site1" && (
            <div className="flex flex-col lg:flex-row items-center justify-center xl:gap-12 gap-6">
              <a
                href="https://www.google.com/maps/search/USA+Qulabz+Inc+16192+Coastal+Highway+Lewes+Delaware,+19958/@38.782478,-75.2334244,12z/data=!3m1!4b1?entry=ttu"
                target="_blank"
                rel="noreferrer"
                className="flex items-center justify-center gap-5 xl:w-[24.3rem] xl:h-[5.37rem] lg:w-[22rem] lg:h-[5rem]  w-[16rem] h-[4.5rem] z-0 hover:border-[0.06rem] hover:border-[#1B99D4]  hover:bg-transparent bg-[#000000] shadow-lg  rounded-2xl px-[1.875rem] py-[0.625rem]"
              >
                <HiOutlineLocationMarker size={24} color="#1B99D4" />
                <div className=" flex flex-wrap sm:w-[18rem] w-[90%] text-left  text-[#ffffff] font-RobotoRegular  text-xs md:text-sm ">
                  USA Qulabz Inc 16192 Coastal Highway Lewes Delaware, 19958
                </div>
              </a>
              <a
                href="https://www.google.com/maps/place/Qulabs+Software+(India)+Pvt.+Ltd./@17.426882,78.4427399,17z/data=!3m1!4b1!4m6!3m5!1s0x3bcb91d51fc46755:0xe39c60f435e2b5dc!8m2!3d17.4268769!4d78.4453148!16s%2Fg%2F11jzpq2lsc?entry=ttu"
                target="_blank"
                rel="noreferrer"
                className="flex items-center justify-center gap-5 xl:w-[24.3rem] xl:h-[5.37rem] lg:w-[22rem] lg:h-[5rem]  w-[16rem] h-[4.5rem] z-0 hover:border-[0.06rem] hover:border-[#1B99D4]  hover:bg-transparent bg-[#000000] shadow-lg  rounded-2xl px-[1.875rem] py-[0.625rem]"
              >
                <HiOutlineLocationMarker size={24} color="#1B99D4" />
                <div className=" flex flex-wrap sm:w-[18rem] w-[90%] text-left  text-[#ffffff] font-RobotoRegular  text-xs md:text-sm ">
                  Qulabs Software Pvt Ltd, 4th floor, Banjara Hills Road No.3,
                  Hyderabad, Telangana
                </div>
              </a>
            </div>
          )}
          {currentSite === "site2" && (
            <>
              {" "}
              <div className="flex flex-col lg:flex-row items-center justify-center xl:gap-12 gap-6">
                <a
                  href="https://maps.app.goo.gl/Y7e6sdXc3U5DjCiD9"
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center justify-center gap-5 xl:w-[24.3rem] xl:h-[5.37rem] lg:w-[22rem] lg:h-[5rem]  w-[16rem] h-[4.5rem] z-0 hover:border-[0.06rem] hover:border-[#1B99D4]  hover:bg-transparent bg-[#000000] shadow-lg  rounded-2xl px-[1.875rem] py-[0.625rem]"
                >
                  <HiOutlineLocationMarker size={24} color="#1B99D4" />
                  <div className="w-[90%] flex flex-wrap sm:w-[18rem]  text-left md:text-center text-[#ffffff] font-opensans  text-xs md:text-sm ">
                    Suite 305B, Capital Park, HITEC City Hyderabad, Telangana
                    500081
                  </div>
                </a>
                <a
                  href="https://www.google.com/maps/place/IT+HILL+NO.3/@17.8070286,83.3764679,16z/data=!4m10!1m2!2m1!1s+Sunrise+Towers,+Hill+no+3,+IT+SEZ+Rushikonda,+Visakhapatnam!3m6!1s0x3a395a5218edb067:0x5038eb17919dc6b!8m2!3d17.8070286!4d83.3852226!15sCjtTdW5yaXNlIFRvd2VycywgSGlsbCBubyAzLCBJVCBTRVogUnVzaGlrb25kYSwgVmlzYWtoYXBhdG5hbVo6IjhzdW5yaXNlIHRvd2VycyBoaWxsIG5vIDMgaXQgc2V6IHJ1c2hpa29uZGEgdmlzYWtoYXBhdG5hbZIBEHNvZnR3YXJlX2NvbXBhbnmaASNDaFpEU1VoTk1HOW5TMFZKUTBGblNVUndYMDFxYWtkbkVBReABAPoBBAgAEDk!16s%2Fg%2F11b7g369qj?entry=ttu&g_ep=EgoyMDI2MDQwNi4wIKXMDSoASAFQAw%3D%3D"
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center justify-center gap-5 xl:w-[24.3rem] xl:h-[5.37rem] lg:w-[22rem] lg:h-[5rem]  w-[16rem] h-[4.5rem] z-0 hover:border-[0.06rem] hover:border-[#1B99D4]  hover:bg-transparent bg-[#000000] shadow-lg  rounded-2xl px-[1.875rem] py-[0.625rem]"
                >
                  <HiOutlineLocationMarker size={24} color="#1B99D4" />
                  <div className=" flex flex-wrap sm:w-[18rem] w-[90%] text-left md:text-center text-[#ffffff] font-RobotoRegular  text-xs md:text-sm ">
                    Sunrise Towers, Hill no 3, IT SEZ Rushikonda, Visakhapatnam
                  </div>
                </a>
              </div>
              <div className="flex flex-col lg:flex-row items-center justify-center xl:gap-12 gap-6">
                <a
                  href="https://www.google.com/maps/place/MEDHA+HI-TECH+CITY/@16.526951,80.7790023,17z/data=!3m1!4b1!4m6!3m5!1s0x3a35e2ce63b8f2fd:0x258a08a7c6cab585!8m2!3d16.5269459!4d80.7815772!16s%2Fg%2F1v6qg0_t?entry=ttu&g_ep=EgoyMDI2MDQwNi4wIKXMDSoASAFQAw%3D%3D"
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center justify-center gap-5 xl:w-[24.3rem] xl:h-[5.37rem] lg:w-[22rem] lg:h-[5rem]  w-[16rem] h-[4.5rem] z-0 hover:border-[0.06rem] hover:border-[#1B99D4]  hover:bg-transparent bg-[#000000] shadow-lg  rounded-2xl px-[1.875rem] py-[0.625rem]"
                >
                  <HiOutlineLocationMarker size={24} color="#1B99D4" />
                  <div className=" flex flex-wrap sm:w-[18rem] w-[90%] text-left md:text-center text-[#ffffff] font-RobotoRegular  text-xs md:text-sm ">
                    MEDHA HI-TECH CITY Amaravathi Quantum Valley (AQV)
                  </div>
                </a>
                <a
                  href="https://www.google.com/maps/place/22+Meridian+Rd+UNIT+14,+Edison,+NJ+08820,+USA/@40.5738238,-74.3495822,17z/data=!3m1!4b1!4m6!3m5!1s0x89c3b6fa09a96f5f:0x4d634cab34602146!8m2!3d40.5738198!4d-74.3470073!16s%2Fg%2F11gg6jwxlw?entry=ttu&g_ep=EgoyMDI2MDQwNi4wIKXMDSoASAFQAw%3D%3D"
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center justify-center gap-5 xl:w-[24.3rem] xl:h-[5.37rem] lg:w-[22rem] lg:h-[5rem]  w-[16rem] h-[4.5rem] z-0  hover:border-[0.06rem] hover:border-[#1B99D4]  hover:bg-transparent bg-[#000000]  shadow-lg  rounded-2xl px-[1.875rem] py-[0.625rem]"
                >
                  <HiOutlineLocationMarker size={24} color="#1B99D4" />
                  <div className=" flex flex-wrap sm:w-[18rem] w-[90%] text-left md:text-center text-[#ffffff] font-RobotoRegular  text-xs md:text-sm ">
                    22 Meridian Rd Unit 14 Edison, NJ 08820, USA
                  </div>
                </a>
              </div>
              <div className="flex flex-col md:flex-row items-center justify-center xl:gap-12 gap-6">
                <a
                  href="https://www.google.com/maps/place/RAKEZ+Compass+Coworking+Centre/@25.6649983,55.6462171,12z/data=!4m10!1m2!2m1!1s++FDRK2335,+Compass+Building+Ras+Al+Khaimah,+UAE!3m6!1s0x3ef60bee567a253b:0x80fd444807765d7!8m2!3d25.6649983!4d55.7862928!15sCi5GRFJLMjMzNSwgQ29tcGFzcyBCdWlsZGluZyBSYXMgQWwgS2hhaW1haCwgVUFFWi4iLGZkcmsyMzM1IGNvbXBhc3MgYnVpbGRpbmcgcmFzIGFsIGtoYWltYWggdWFlkgEPY293b3JraW5nX3NwYWNl4AEA!16s%2Fg%2F11nyr0jmqk?entry=ttu&g_ep=EgoyMDI2MDQwNi4wIKXMDSoASAFQAw%3D%3D"
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center justify-center gap-5 xl:w-[24.3rem] xl:h-[5.37rem] lg:w-[22rem] lg:h-[5rem]  w-[16rem] h-[4.5rem] z-0 hover:border-[0.06rem] hover:border-[#1B99D4]  hover:bg-transparent bg-[#000000] shadow-lg  rounded-2xl px-[1.875rem] py-[0.625rem]"
                >
                  <HiOutlineLocationMarker size={24} color="#1B99D4" />
                  <div className=" flex flex-wrap sm:w-[18rem] w-[90%] text-left md:text-center text-[#ffffff] font-RobotoRegular  text-xs md:text-sm ">
                    FDRK2335, Compass Building Ras Al Khaimah, UAE
                  </div>
                </a>
              </div>
            </>
          )}
          {/* <div className="flex flex-col lg:flex-row items-center justify-center xl:gap-12 gap-6">
            <a
              href="https://www.google.com/maps/place/MEDHA+HI-TECH+CITY/@16.526951,80.7790023,17z/data=!3m1!4b1!4m6!3m5!1s0x3a35e2ce63b8f2fd:0x258a08a7c6cab585!8m2!3d16.5269459!4d80.7815772!16s%2Fg%2F1v6qg0_t?entry=ttu&g_ep=EgoyMDI2MDQwNi4wIKXMDSoASAFQAw%3D%3D"
              target="_blank"
              rel="noreferrer"
              className="flex items-center justify-center gap-5 xl:w-[24.3rem] xl:h-[5.37rem] lg:w-[22rem] lg:h-[5rem]  w-[16rem] h-[4.5rem] z-0 hover:border-[0.06rem] hover:border-[#1B99D4]  hover:bg-transparent bg-[#000000] shadow-lg  rounded-2xl px-[1.875rem] py-[0.625rem]"
            >
              <HiOutlineLocationMarker size={24} color="#1B99D4" />
              <div className=" flex flex-wrap sm:w-[18rem] w-[90%] text-left md:text-center text-[#ffffff] font-RobotoRegular  text-xs md:text-sm ">
                MEDHA HI-TECH CITY Amaravathi Quantum Valley (AQV)
              </div>
            </a>
            <a
              href="https://www.google.com/maps/place/22+Meridian+Rd+UNIT+14,+Edison,+NJ+08820,+USA/@40.5738238,-74.3495822,17z/data=!3m1!4b1!4m6!3m5!1s0x89c3b6fa09a96f5f:0x4d634cab34602146!8m2!3d40.5738198!4d-74.3470073!16s%2Fg%2F11gg6jwxlw?entry=ttu&g_ep=EgoyMDI2MDQwNi4wIKXMDSoASAFQAw%3D%3D"
              target="_blank"
              rel="noreferrer"
              className="flex items-center justify-center gap-5 xl:w-[24.3rem] xl:h-[5.37rem] lg:w-[22rem] lg:h-[5rem]  w-[16rem] h-[4.5rem] z-0  hover:border-[0.06rem] hover:border-[#1B99D4]  hover:bg-transparent bg-[#000000]  shadow-lg  rounded-2xl px-[1.875rem] py-[0.625rem]"
            >
              <HiOutlineLocationMarker size={24} color="#1B99D4" />
              <div className=" flex flex-wrap sm:w-[18rem] w-[90%] text-left md:text-center text-[#ffffff] font-RobotoRegular  text-xs md:text-sm ">
                22 Meridian Rd Unit 14 Edison, NJ 08820, USA
              </div>
            </a>
          </div>
          <div className="flex flex-col md:flex-row items-center justify-center xl:gap-12 gap-6">
            <a
              href="https://www.google.com/maps/place/RAKEZ+Compass+Coworking+Centre/@25.6649983,55.6462171,12z/data=!4m10!1m2!2m1!1s++FDRK2335,+Compass+Building+Ras+Al+Khaimah,+UAE!3m6!1s0x3ef60bee567a253b:0x80fd444807765d7!8m2!3d25.6649983!4d55.7862928!15sCi5GRFJLMjMzNSwgQ29tcGFzcyBCdWlsZGluZyBSYXMgQWwgS2hhaW1haCwgVUFFWi4iLGZkcmsyMzM1IGNvbXBhc3MgYnVpbGRpbmcgcmFzIGFsIGtoYWltYWggdWFlkgEPY293b3JraW5nX3NwYWNl4AEA!16s%2Fg%2F11nyr0jmqk?entry=ttu&g_ep=EgoyMDI2MDQwNi4wIKXMDSoASAFQAw%3D%3D"
              target="_blank"
              rel="noreferrer"
              className="flex items-center justify-center gap-5 xl:w-[24.3rem] xl:h-[5.37rem] lg:w-[22rem] lg:h-[5rem]  w-[16rem] h-[4.5rem] z-0 hover:border-[0.06rem] hover:border-[#1B99D4]  hover:bg-transparent bg-[#000000] shadow-lg  rounded-2xl px-[1.875rem] py-[0.625rem]"
            >
              <HiOutlineLocationMarker size={24} color="#1B99D4" />
              <div className=" flex flex-wrap sm:w-[18rem] w-[90%] text-left md:text-center text-[#ffffff] font-RobotoRegular  text-xs md:text-sm ">
                FDRK2335, Compass Building Ras Al Khaimah, UAE
              </div>
            </a>
          </div> */}
        </div>
      )}
      <div className="width w-full flex flex-col items-center justify-center ">
        <div className="w-full  md:w-[85%] flex flex-col md:flex-row items-center justify-center gap-0 md:gap-10">
          {/* Logo Section */}
          <div className="w-[16rem] h-[16rem] flex  items-center justify-center">
            {currentSite === "site1" ? (
              <img
                className="w-[12rem] h-[10rem] 2xl:w-[8rem] 2xl:h-[6rem]"
                src={logoSVG}
                alt="Quantum Logo"
              />
            ) : (
              <img
                className="w-full h-full md:w-[10rem] md:h-[10rem]"
                src={logoQAIGSVG}
                alt="Quantum Logo"
              />
            )}
          </div>

          {/* Grid Content Section */}
          <div className="w-[60%] grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-x-2 gap-y-6 pb-10 md:pb-0">
            {/* Product */}
            <div className="font-RobotoRegular">
              <div className="text-[#1B99D4] font-semibold text-lg  mb-1.5">
                Product
              </div>
              <ul className="text-[#798397] text-sm space-y-1.5">
                <li
                  onClick={() => {
                    scrollToTop();
                    navigate("/Products/Hardware");
                  }}
                  className="cursor-pointer hover:text-white"
                >
                  Quantum Hardware
                </li>
                <li
                  onClick={() => {
                    scrollToTop();
                    navigate("/Products/Software");
                  }}
                  className="cursor-pointer hover:text-white"
                >
                  Quantum Software
                </li>
                <li
                  onClick={() => {
                    scrollToTop();
                    navigate("/Ourip");
                  }}
                  className="cursor-pointer hover:text-white"
                >
                  Our IP's
                </li>
              </ul>
            </div>

            {/* Company */}
            <div className="font-RobotoRegular">
              <div className="text-[#1B99D4] font-semibold text-lg  mb-1.5">
                Company
              </div>
              <ul className="text-[#798397] text-sm space-y-1.5">
                <li
                  onClick={() => {
                    scrollToTop();
                    navigate("/Company/AboutUs");
                  }}
                  className="cursor-pointer hover:text-white"
                >
                  About us
                </li>
                <li
                  onClick={() => {
                    scrollToTop();
                    navigate("/Company/ContactUs");
                  }}
                  className="cursor-pointer hover:text-white"
                >
                  Contact us
                </li>
                <li
                  onClick={() => {
                    scrollToTop();
                    navigate("/Publications");
                  }}
                  className="cursor-pointer hover:text-white"
                >
                  Publications
                </li>
              </ul>
            </div>

            {/* Brochures */}
            {/* <div className="font-RobotoRegular">
              <div className="text-[#1B99D4] font-semibold md:text-lg text-sm mb-1.5">
                Brochures
              </div>
              <ul className="text-[#798397] text-xs md:text-sm space-y-1.5">
                <li className="cursor-pointer hover:text-white">
                  <a
                    href="/brochures/QAIG Introduction Brochure.pdf"
                    download="QAIG Introduction Brochure.pdf"
                  >
                    QAIG Introduction Brochure
                  </a>
                </li>
                <li className="cursor-pointer hover:text-white">
                  <a
                    href="/brochures/QAIG Quantum Solutions for Academia.pdf"
                    download="QAIG Quantum Solutions for Academia.pdf"
                  >
                    QAIG Quantum Solutions for Academia
                  </a>
                </li>
              </ul>
            </div> */}

            {/* Contact Us */}
            <div className="font-RobotoRegular">
              <div className="text-[#1B99D4] font-semibold text-lg  mb-1.5">
                Contact Us
              </div>
              <ul className="text-[#798397] text-sm space-y-2">
                <li>
                  {currentSite === "site1" && (
                    <div className="flex items-center justify-start gap-2.5">
                      <TbMail size={18} color="#1B99D4" />
                      <span className="align-middle">info@qulabs.ai</span>
                    </div>
                  )}
                  {currentSite === "site2" && (
                    <div className="flex items-center gap-2.5">
                      <TbMail size={18} color="#1B99D4" />
                      <span>info@thequantum.ai</span>
                    </div>
                  )}
                </li>
                <li>
                  <div className="flex items-center justify-start gap-2.5">
                    <IoCallOutline size={18} color="#1B99D4" />
                    <span className="align-middle">
                      {currentSite === "site1"
                        ? "91 62816 84342"
                        : "+91 81210 27006"}
                    </span>
                  </div>
                </li>
                <li onClick={currentSite === "site1" ? openLinkedInProfile : openQAIGLinkedInProfile} className="cursor-pointer">
                  <div className="flex items-center justify-start gap-2.5">
                    <SlSocialLinkedin size={18} color="#1B99D4" />
                    <span className="align-middle">LinkedIn</span>
                  </div>
                </li>
                {/* <li className="flex items-center gap-2.5 mt-2">
                  <div
                    onClick={openLinkedInProfile}
                    className="video-icon p-3 bg-[#1B99D4]/20 rounded-full"
                  >
                    <SlSocialLinkedin size={20} color="#1B99D4" />
                  </div>
                  <div onClick={openTwitterProfile} className="video-icon">
                    <FaXTwitter size={21} color="#1B99D4" />
                  </div>
                  <div onClick={openYoutubeProfile} className="video-icon">
                    <FiYoutube size={20} color="#1B99D4" />
                  </div>
                </li> */}
              </ul>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-center w-full  border-t-2 border-[#1B99D4] bg-primary7">
          <div className="width md:w-[70%] w-full  mt-[0.1rem] flex items-center justify-between  ">
            <div className="flex w-[50%] px-2 sm:px-1">
              <div className="text-[#ffffff] font-opensans 2xl:text-xs md:text-[0.6rem] text-[0.45rem]">
                Copyright © 2023 I
              </div>
              <div className="text-[#1B99D4] font-opensans 2xl:text-xs md:text-[0.6rem] text-[0.45rem]">
               {currentSite === "site1" ? "Qulabs" : "Quantum AI Global"}
              </div>
            </div>
            <div className="flex items-center justify-end w-[50%] gap-1">
              <div className="text-[#ffffff] font-opensans 2xl:text-xs md:text-[0.6rem] text-[0.45rem]">
                All Rights Reserved I
              </div>
              <div className="text-[#1B99D4] font-opensans 2xl:text-xs md:text-[0.6rem] text-[0.45rem]">
                Terms and Conditions I Privacy Policy
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
